/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel2";
// import 'react-owl-carousel2/lib/styles.css'
import PropTypes from "prop-types";
import Query from "components/Query";
// import Video from './Video'
import Comment from "./Comment";
import "react-owl-carousel2/lib/styles.css";
import { Link, useHistory } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;



const Testimonials = React.memo(({ commentsUrl }) => {

  const history = useHistory();

  const options = {
    responsive: {
      0: {
        items: 1, // On mobile, display 1 item
      },
      768: {
        items: 2, // On desktop (768px and above), display 2 items
      },
    },
    nav: true,
    margin: 10,
    rewind: true,
    autoplay: true,
    autoplayTimeout: 5000,
    dots: false,
    navText: [
      '<img src="/img/arrow-button-left.svg" id="custom-prev">',
      '<img src="/img/arrow-button-right.svg" id="custom-next">'
    ],
    // navText: [
    //   '<span aria-label="Previous">‹</span>',
    //   '<span aria-label="Next">›</span>',
    // ],
  };

  const [buttonId, setButtonId] = useState();

  const handleMouseEnter = (id) => {
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setButtonId("");
  };


  // const { loading: l1, error: e1, response: vidsRes } = useFetching(videosUrl)
  // const { loading: l2, error: e2, response: commentsRes } = useFetching(commentsUrl)

  // let shortTestimonials = []
  // const shortTestimonials = commentsRes && commentsRes.data
  // if (commentsRes && commentsRes.data) {
  //   shortTestimonials = commentsRes.data.filter(i => i.comment.length < 233)
  //   // console.log(shortTestimonials)
  //   if (shortTestimonials.length === 0) {
  //     shortTestimonials = commentsRes.data.map(i => ({
  //       ...i,
  //       comment: `${i.comment.slice(0, 250)}...`,
  //     }))
  //     //  console.log(shortTestimonials)
  //   }
  // }

  // console.log(renderVideos, renderTestimonials)
  return (
    // <>
    //   <Query url={commentsUrl}>
    //     {({ data }) => {
    //       let shortTestimonials = []
    //       if (data) {
    //         shortTestimonials = data.filter(i => i.comment.length < 300)
    //         if (shortTestimonials.length === 0) {
    //           shortTestimonials = data.map(i => ({
    //             ...i,
    //             comment: `${i.comment.slice(0, 250)}...`,
    //           }))
    //         }
    //       }
    //       console.log('shrt testimonials',shortTestimonials)
    //       return (
    //         <OwlCarousel
    //           options={options}
    //           className="owl-carousel owl-theme testimonials-slider nav-middle mobile-carousel"
    //         >
    //           {shortTestimonials.map(i => (
    //             <div key={i._id} className="item">
    //               <Comment
    //                 imageTag={i.imageTag}
    //                 name={i.name}
    //                 comment={i.comment}
    //                 image={i.image ? i.image.thumbnail : ''}
    //                 location = {i.location}
    //               />
    //             </div>
    //           ))}
    //         </OwlCarousel>
    //       )
    //     }}
    //   </Query>
    // </>
    <>
      <div>
        <Query url={commentsUrl}>
          {({ data }) => {
            let shortTestimonials = [];
            if (data) {
              shortTestimonials = data.filter((i) => i.comment.length < 300);
              if (shortTestimonials.length === 0) {
                shortTestimonials = data.map((i) => ({
                  ...i,
                  comment: `${i.comment.slice(0, 250)}...`,
                }));
              }
            }
            console.log("shrt testimonials", shortTestimonials);
            return (
              <OwlCarousel
                options={options}
                className="mobile-carousel owl-carousel owl-theme  nav-middle "
              >
                {shortTestimonials.map((i) => (
                  <div className="comments-wrapper">
                    <Link to="/testimonials">
                      <div
                        className="testimonial-outer-div"
                        style={{ padding: "20px 30px" }}
                      >
                        <div className="testimonial-inside">
                          <img src="/img/double-coma.svg" />
                          <p>{i.comment}</p>
                          <h6>{i.name}</h6>
                          <h5>{i.location}</h5>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </OwlCarousel>
            );
          }}
        </Query>
      </div>
      <div className="testimonial-button-div">
        <button
          onMouseEnter={() => {
            handleMouseEnter("testimonials");
          }}
          onMouseLeave={handleMouseLeave}
          className="testimonial-view-all"
          onClick={()=>history.push('/testimonials')}
        >
          <span>Read More</span>
          <img src={
                      buttonId == "testimonials"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
        </button>
      </div>
    </>
  );
  // return (
  //   <>
  //     {l2 && <Loader />}
  //     {e2 && <ErrorMessage message={e2.message} />}
  //     {commentsRes && commentsRes.data && (
  //       <OwlCarousel
  //         options={options}
  //         className="owl-carousel owl-theme testimonials-slider nav-middle"
  //         // events={events}
  //       >
  //         {/* {vidsRes.data.map(i => (
  //           <div key={i._id} className="item">
  //             <Video videoId={i.videoId} onClick={id => handleVideoClick(id)} />
  //           </div>
  //         ))} */}
  //         {shortTestimonials.map(i => (
  //           <div key={i._id} className="item">
  //             <Comment name={i.name} comment={i.comment} image={i.image ? i.image.thumbnail : ''} />
  //           </div>
  //         ))}
  //       </OwlCarousel>
  //     )}
  //   </>
  // )
});

Testimonials.propTypes = {
  commentsUrl: PropTypes.string,
};

Testimonials.defaultProps = {
  commentsUrl: BASE_URL + "/api/comments",
};

export default Testimonials;
